import i18n from "../i18n.js";
import __i18n_zh_screens_default from "../../public/i18n/screens/default.zh.json";
if (!i18n.hasResourceBundle("zh", "screens.default")) { i18n.addResourceBundle("zh", "screens.default", __i18n_zh_screens_default, true); }
import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {startsWith} from "lodash";
import { connect } from "react-redux";
import { ConfigProvider } from "antd";
import { px2remTransformer, StyleProvider } from "@ant-design/cssinjs";
import { withTranslation } from "react-i18next";

import "../styles/index.scss";

import BaseScreen from "../components/base/BaseScreen";
import { getAntdLocale } from "../i18n";
import { NavigationService } from "../navigation";
import { ActionTypes } from "../redux/actionTypes/screens/DefaultActionTypes";
import { Actions, reducer, INITIAL_STATE } from "../redux/screens/DefaultRedux";
import { Actions as SessionActions } from "../redux/SessionRedux";
import { Actions as TaskActions } from "../redux/TaskRedux";
import PendingTasksPollingService from "../services/PendingTasksPollingService";
import UIDs from "../UIDs";
import { ErrorPage } from "../components/base/RouteErrorScreen";
import { customAntdDarkTheme, customAntdLightTheme, styleContextValue } from "../styles/antd-theme";
import { StylesContext } from "../context";
import { AntdApp } from "../components/antdApp";

const PortalLayout = React.lazy(() => import("../layouts/PortalLayout"));
//const PlainLayout = React.lazy(() => import("../layouts/PlainLayout"));
const AccountLayout = React.lazy(() => import("../layouts/AccountLayout"));
// const DashBoardLayout = React.lazy(() => import("../layouts/DashBoardLayout"));
// const MainLayout = React.lazy(() => import("../layouts/MainLayout"));
const AdminLayout = React.lazy(() => import("../layouts/AdminLayout"));
// const UserProfileLayout = React.lazy(() => import("../layouts/UserProfileLayout"));
// const CorporateLayout = React.lazy(() => import("../layouts/CorporateLayout"));

const uid = UIDs.screens.default;
const px2rem = px2remTransformer({
    rootValue: 16, // 32px = 1rem; @default 16
});

class DefaultScreen extends BaseScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_APP_ASYNC]: { done: this._handleLoadAppAsyncDone, error: null },
        };
    }

    // constructor(props) {
    //   super(props);

    //   // create store when app starts
    //   // this._store = StoreManager.getStore();
    // }

    componentDidMount() {
        super.componentDidMount();

        document.title = this.props.t("yofrive");

        // load session from local storage if any
        this.props.tryLoadSession();

        // load necessary data to initialize the app
        this.props.loadAppAsync();

        //load task from local storage
        this.props.loadTask();
        
        // 检查用户是否已登录，如果已登录则启动轮询服务
        if (this.isLoggedIn(this.props.userId)) {
            PendingTasksPollingService.startPolling();
        }
    }

    render() {
        if (!this.isActionDone(ActionTypes.LOAD_APP_ASYNC)) {
            return <div className="loader"></div>;
        } else {
            return (
                <ConfigProvider locale={getAntdLocale()} theme={this.props.mytheme === "dark" ? customAntdDarkTheme : customAntdLightTheme}>
                    <StylesContext.Provider
                        value={{
                            ...styleContextValue,
                        }}>
                        <StyleProvider transformers={[px2rem]}>
                            <AntdApp>
                                <Suspense fallback={<div className="loader"></div>}>
                                    <Switch>
                                        <Route path="/account" component={AccountLayout} />
                                        <Route path="/portal" component={PortalLayout} />
                                        {/*<Route path="/plain" component={PlainLayout} />*/}
                                        {/* <Route path="/dashboards" component={DashBoardLayout} /> */}
                                        {/* <Route path="/userProfile" component={UserProfileLayout} /> */}
                                        {/*<Route path="/main" component={MainLayout} />*/}
                                        {/* <Route path="/main" component={MainLayout} /> */}
                                        <Route path="/admin" component={AdminLayout} />
                                        {/* <Route path="/corporate" component={CorporateLayout} /> */}
                                        {/* <Route path="/">
                                            <Redirect
                                                to={{
                                                    pathname: this._getDefaultPath(),
                                                }}
                                            />
                                        </Route> */}
                                        <Route path="*">
                                            <ErrorPage />
                                        </Route>
                                    </Switch>
                                </Suspense>
                            </AntdApp>
                        </StyleProvider>
                    </StylesContext.Provider>
                </ConfigProvider>
            );
        }
    }

    _handleLoadAppAsyncDone = () => {
        if (startsWith(this.props.location.pathname, "/plain/")) {
            //do nothing
        } else if (!this.isLoggedIn(this.props.userId) && !startsWith(this.props.location.pathname, "/account/") && !startsWith(this.props.location.pathname, "/portal/")) {
            NavigationService.navigateToPageByUID(this, UIDs.screens.portal.home);
        } else if (this.props.location.pathname === "/") {
            // if (this.isEmployee) {
            //     NavigationService.navigateToPageByUID(this, UIDs.screens.admin.error.dashboard);
            // } else if (this.isRegionAdmin) {
            //     NavigationService.navigateToPageByUID(this, UIDs.screens.admin.region.list);
            // } else if (this.isRegionUser) {
            //     NavigationService.navigateToPageByUID(this, UIDs.screens.admin.chat.list);
            // } else {
            NavigationService.navigateToPageByUID(this, UIDs.screens.admin.workbench);
            //}
        }
    };

    _getDefaultPath() {
        if (startsWith(this.props.location.pathname, "/plain/")) {
            //do nothing
            return "/portal/home";
        } else if (!this.isLoggedIn(this.props.userId) && !startsWith(this.props.location.pathname, "/account/") && !startsWith(this.props.location.pathname, "/portal/")) {
            return "/portal/home";
        } else if (this.props.location.pathname === "/") {
            // if (this.isEmployee) {
            //     return "/admin/error/dashboard";
            // } else
            //if (this.isRegionAdmin) {
                //return "/admin/region/list";
            //} else {
                return "/admin/dashboard";
            //}
        }
    }
    
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        
        // 监听用户登录状态变化
        const wasLoggedIn = this.isLoggedIn(prevProps.userId);
        const isLoggedIn = this.isLoggedIn(this.props.userId);
        
        if (!wasLoggedIn && isLoggedIn) {
            PendingTasksPollingService.startPolling();
        }
        else if (wasLoggedIn && !isLoggedIn) {
            PendingTasksPollingService.stopPolling();
        }
    }
    
    componentWillUnmount() {
        super.componentWillUnmount();
        
        // 停止轮询服务
        PendingTasksPollingService.stopPolling();
    }
}

const mapStateToProps = (state) => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user,
        mytheme: state.theme.mytheme,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadAppAsync: () => dispatch(Actions.loadAppAsync()),
        tryLoadSession: () => dispatch(SessionActions.tryLoadSession()),
        loadTask: () => dispatch(TaskActions.loadTask()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(DefaultScreen));
